import StoryRiverView from 'src/components/StoryRiverView'
import { useSelector } from 'react-redux'
import { getViewByName } from 'src/features/views/ViewsSelector'
import useViewProps from 'src/hooks/useViewProps'

const ResearchWithKOL = () => {
  const title = 'Research With Kols'
  const view = useSelector(getViewByName('research with kols')) || null
  const { viewsError, viewsLoading, handleViewMoreClick } = useViewProps()

  return (
    <StoryRiverView
      view={view}
      viewsError={viewsError}
      viewsLoading={viewsLoading}
      handleViewMoreClick={() => handleViewMoreClick('home', title)}
      title={title}
      viewMore={{
        to: '/river/tag/fw_report_stakeholders/KOLs',
        show: true,
        handleMore: title
      }}
      includeTags={false}
      imagesLength={true}
      showActionBar={true}
      actionButtonsConfig={{
        sharedButtonsConfig: {
          align: 'right'
        }
      }}
    />
  )
}

export default ResearchWithKOL
